/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive} from '@angular/core';
/**
 * Suffix to be placed at the end of the form field.
 */
export class MdSuffix {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mdSuffix], [matSuffix]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSuffix_tsickle_Closure_declarations() {
/** @type {?} */
MdSuffix.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSuffix.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
